import { openNewTab, openMail } from "./footerUtils";
import i18n from "i18n";

/**
 * Default support email used for mailto links.
 */
export const SUPPORT_EMAIL = "support@campusguardianangel.com";

/**
 * footerLinks
 * - Centralized configuration for footer actions.
 * - Each link has a label + an onClick handler.
 */
export const footerLinks = [
  {
    label: "FAQ",
    onClick: (e) =>
      openNewTab(e, "https://www.campusguardianangel.com/faq"),
  },
  {
    get label() { return i18n.t("layout:support"); },
    onClick: (e) => openMail(e, SUPPORT_EMAIL),
  },
  {
    get label() { return i18n.t("layout:feedback"); },
    onClick: (e) => openMail(e, SUPPORT_EMAIL),
  },
  {
    get label() { return i18n.t("layout:terms"); },
    onClick: (e) =>
      openNewTab(e, "https://www.campusguardianangel.com/terms-of-service"),
  },
];
